export const NEW_PROFILE_ID = -1;

export const INIT_PROFILE = {
    profileId: NEW_PROFILE_ID,
    isPrimary: false,
    usersCounts: 0,
    profileName: '',
    profileDescription: '',
    rightsCodes: [],
};
